module.exports = __webpack_public_path__ + "img/bye-sorry-ok.54be6888.jpg";